module.exports = __webpack_public_path__ + "media/bootstrap-icons/door-open-fill-f3af10bb.svg";